import React from 'react';

export default function SegmentedPicker({ options, selectedOption, setSelectedOption }) {
  return (
    <div
      className="mobile-panel-picker frosted"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {options.map((option) => (
        <div
          key={option.key}
          style={{
            padding: '4px',
            cursor: 'pointer',
            backgroundColor: selectedOption === option.key
              ? 'rgba(142, 142, 147, 0.4)' : 'transparent',
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            fontWeight: selectedOption === option.key ? 'bold' : 'normal'
          }}
          onClick={() => setSelectedOption(option.key)}
        >
          <option.icon />
          <span style={{ marginLeft: '4px' }}>{option.label}</span>
        </div>
      ))}
    </div>
  );
}
